module.exports = __webpack_public_path__ + "static/header_glow-f3710bc8418b5fa54c1ee7dc738a1d7c.png";